<form [formGroup]="form" class="container-fluid container-filter" autocomplete="off">

    <div class="animated fadeIn">

        <div class="row">
            <div class="col-md-12">
                <h4>Buscador de Transiciones de Estados para las Unidades de Inspección de Campañas</h4>

                <div class="card card-accent-success animated fadeIn">
                    <a class="card-header-a" (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed"
                       aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-filter"></i> Filtros
                            <i *ngIf="isCollapsed" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsed" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>
                    <div class="card-body">

                        <div class="collapse group-filtros" id="collapseFiltros" [ngbCollapse]="isCollapsed">

                            <div class="row">

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpPerfil">Perfil del usuario</label>

                                    <ng-select [items]="listPerfilesUsuario"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdPerfilUsuario"
                                               loadingText="Cargando..."
                                               [loading]="!(listPerfilesUsuario)"
                                               notFoundText="Perfil no encontrado"
                                               placeholder="-- Seleccione un Perfil --"
                                               clearAllText="Eliminar selección"
                                               [ngClass]="displayFieldCssNgSelect('IdPerfilUsuario')"
                                               appendTo="body">
                                    </ng-select>
                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpTipoInspeccionCam">Tipo de Inspección</label>

                                    <ng-select [items]="listTiposInspeccionCam"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdTipoInspeccionCam"
                                               loadingText="Cargando..."
                                               [loading]="!(listTiposInspeccionCam)"
                                               notFoundText="Tipo de inspección no encontrado"
                                               placeholder="-- Seleccione un Tipo de inspección --"
                                               clearAllText="Eliminar selección"
                                               [ngClass]="displayFieldCssNgSelect('IdTipoInspeccionCam')"
                                               appendTo="body">
                                    </ng-select>
                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpEstado">Estado de la Unidad de Inspección</label>

                                    <ng-select [items]="listEstadosUnidadInspeccionCam"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdEstadoUnidadInspeccionCam"
                                               loadingText="Cargando..."
                                               [loading]="!(listEstadosUnidadInspeccionCam)"
                                               notFoundText="Estado no encontrado"
                                               placeholder="-- Seleccione un Estado --"
                                               clearAllText="Eliminar selección"
                                               [ngClass]="displayFieldCssNgSelect('IdEstadoUnidadInspeccionCam')"
                                               appendTo="body">
                                    </ng-select>
                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpResultado">Resultado de la Inspección</label>

                                    <ng-select [items]="listResultadosInspeccionCam"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdResultadoInspeccionCam"
                                               loadingText="Cargando..."
                                               [loading]="!(listResultadosInspeccionCam)"
                                               notFoundText="Resultado no encontrado"
                                               placeholder="-- Seleccione un Resultado --"
                                               clearAllText="Eliminar selección"
                                               [ngClass]="displayFieldCssNgSelect('IdResultadoInspeccionCam')"
                                               appendTo="body">
                                    </ng-select>
                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpEstado">Siguiente Estado de la Unidad de Inspección</label>

                                    <ng-select [items]="listEstadosUnidadInspeccionCam"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdSiguienteEstadoUnidadInspeccionCam"
                                               loadingText="Cargando..."
                                               [loading]="!(listEstadosUnidadInspeccionCam)"
                                               notFoundText="Estado no encontrado"
                                               placeholder="-- Seleccione el siguiente Estado --"
                                               clearAllText="Eliminar selección"
                                               [ngClass]="displayFieldCssNgSelect('IdSiguienteEstadoUnidadInspeccionCam')"
                                               appendTo="body">
                                    </ng-select>
                                </div>

                            </div>

                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group-0 float-right">

                                    <div class="btn-group">
                                        <button name="btnSearch" class="btn btn-secondary btn-sm" type="submit" [disabled]="disableSearchBtn"
                                                title="Realiza una búsqueda" (click)="onSearch($event)">
                                            <i class="fa fa-search"></i> Buscar
                                        </button>
                                    </div>

                                    <div class="btn-group">
                                        <button class="btn btn-secondary btn-sm" type="button" [disabled]="formIsUntouched()"
                                                title="Limpia los filtros" (click)="resetForm($event)">
                                            <i class="fa fa-eraser"></i> Limpiar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

</form>
